module.exports = __webpack_public_path__ + "static/media/04.caf565ce.jpg";